<script>
    export default {
        props: {
            item: {
                type: Object,
                required: true
            },
            searchText: {
                type: String,
                required: true
            }
        }
    }
</script>

<template>
    <div>
        <svg width="24" height="24" viewBox="0 0 22 15" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15.128 0c1.026 0 1.862.803 1.862 1.791V3.57l3.664-1.752a.967.967 0 01.905.041.887.887 0 01.441.761v9.758c0 .31-.167.598-.441.762a.965.965 0 01-.905.04l-3.664-1.753v1.782c0 .988-.836 1.791-1.862 1.791H1.862C.836 15 0 14.197 0 13.209V1.791C0 .803.836 0 1.862 0zm0 1.791H1.862v11.418H15.13v-2.905a.854.854 0 01-.09-.365V5.058c0-.129.036-.25.09-.364l-.002-2.903zM12.13 9.474c.502 0 .908.353.908.79 0 .436-.406.789-.908.789H4.982c-.502 0-.908-.353-.908-.79 0-.436.406-.79.908-.79zm8.009-5.408L16.99 5.57v3.856l3.148 1.507V4.066z" fill="currentColor"/></svg>
        <strong>{{ item.name }}</strong>
        <BaseStatus :online="true"></BaseStatus>
    </div>
</template>
